/**
 * BHA Event-Day Liability Waiver Content
 * Version 1.0 - Effective January 1, 2025
 */

export const WAIVER_VERSION = '1.0';

export const WAIVER_CONTENT = {
  title: 'Black Heart Association (BHA) Event-Day Liability Waiver',
  
  waiverStatement: {
    intro: 'I understand that by participating in this Black Heart Association (BHA) event, I am volunteering my time and services. I acknowledge that:',
    points: [
      'Participation may involve certain risks, including but not limited to minor injuries, illness, or accidents.',
      'BHA is not responsible for personal injury, illness, or accidents that occur due to negligence, failure to follow instructions, or actions outside the scope of assigned duties.',
      'I agree to follow all safety instructions provided by BHA staff and event coordinators.',
      'In case of emergency, I authorize BHA staff to seek medical assistance on my behalf.',
      'I am responsible for any medical expenses incurred.'
    ],
    acknowledgmentText: 'I have read and understand all of the above statements and agree to these terms.'
  },
  
  consentRelease: {
    title: 'Consent & Release',
    text: 'By signing below, I release and discharge the Black Heart Association, its staff, interns, contractors, and volunteers from any liability, claims, or demands arising from my participation in this event.'
  }
};

export const MEDICAL_EXPERIENCE_OPTIONS = [
  'No Medical Experience',
  'Physician/Doctor',
  'Nurse',
  'Medical Student',
  'Nursing Student',
  'Technician',
  'Phlebotomist',
  'Other Healthcare Professional'
];

export const VOLUNTEER_AREA_OPTIONS = [
  {
    value: 'Registration Assistant',
    label: 'Registration Assistant',
    description: 'Technology savvy, ability to multitask, strong interpersonal skills a plus'
  },
  {
    value: 'Digital Media Assistant',
    label: 'Digital Media Assistant',
    description: 'Passion for photography, videography, comfortable with social media platforms'
  },
  {
    value: 'Quality Assurances',
    label: 'Quality Assurances',
    description: 'Strong interpersonal, passion for assessing/improving organizations customer services'
  },
  {
    value: 'Tester',
    label: 'Tester',
    description: 'Medical Training/Phlebotomy Certification and Experience required! *Must provide credentials'
  }
];

export default WAIVER_CONTENT;
